// extracted by mini-css-extract-plugin
export default {"works":"Works_works__znDgU","heading":"Works_heading__JoJOW"};